import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function HammerIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M31 7.25h-3.75v2.5H31v-2.5Zm-6.52 9.4-1.96 1.54 2.3 2.95 1.98-1.54-2.32-2.95Zm2.62-4.21-1.23 2.18 3.27 1.84 1.22-2.17-3.26-1.85Zm-18.6.3L1 27.58 7.75 31l7.49-14.84-6.75-3.42Zm14.63 1.81 1.97-3.9A2.5 2.5 0 0 0 24 7.3L13.33 1.88c-4-2.03-8.9-.43-10.92 3.57l-.57 1.11 17.92 9.1a2.5 2.5 0 0 0 3.36-1.1Z"
      />
    </BaseIcon>
  );
}
